import { assign } from 'xstate';
import { Context } from '../companyInfo';

const assignLoadingData = assign<Context, any>((ctx, evt) => ({
    isFetching: true,
}));

export default assignLoadingData;
